enum RideFilterType {
  departureStationId = "departureStationId",
  lineId = "lineId",
  departureTime = "departureTime",
}

export default RideFilterType;
